import { ObjectHelper } from "../Helpers/ObjectHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerGreaterThanOrEqualToPropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerGreaterThanOrEqualToProperties = {
    [name in keyof PropertyComparerGreaterThanOrEqualToPropertyValues]: Property<PropertyComparerGreaterThanOrEqualToPropertyValues[name]>
};

export interface IPropertyComparerGreaterThanOrEqualTo extends IPropertyComparer, PropertyComparerGreaterThanOrEqualToProperties
{
}

export class PropertyComparerGreaterThanOrEqualTo extends PropertyComparer<PropertyComparerGreaterThanOrEqualToPropertyValues> implements IPropertyComparerGreaterThanOrEqualTo
{
    public static override classNamespace = NAMESPACE + "PropertyComparerGreaterThanOrEqualTo";
    public static override className = "PropertyComparerGreaterThanOrEqualTo";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return ObjectHelper.compare(propertyValue, constantValue) >= 0;
    }

    // #endregion
}

